export default __webpack_public_path__ + "static/media/search.99bb8383.svg";